import { useAccount, useBalance } from "wagmi";

export function useBNBBalance() {
  const { address } = useAccount();
  const {
    data,
    error,
    isLoading,
    refetch: refetchBNBBalance,
  } = useBalance({
    address: address as `0x${string}`,
  });

  if (isLoading) return null;

  if (error) {
    console.log(error);
    return null;
  }

  if (!data) return null;

  return { bnbBalance: data, refetchBNBBalance, isLoading };
}
